import { createFileRoute } from "@tanstack/react-router";

import textLogo from "@/assets/images/text.png";
import { m } from "@/paraglide/messages.js";

const LAST_UPDATED = "July 24, 2026";

const SECTIONS = [
  {
    title: "Overview",
    body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  },
  {
    title: "Information We Collect",
    body: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  },
  {
    title: "How We Use Information",
    body: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
  },
  {
    title: "Sharing",
    body: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet.",
  },
  {
    title: "Data Retention",
    body: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident.",
  },
  {
    title: "Your Rights",
    body: "Similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio nam libero tempore cum soluta nobis est eligendi.",
  },
  {
    title: "Changes",
    body: "Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus.",
  },
  {
    title: "Contact",
    body: "Ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat. Replace this placeholder copy with your own privacy policy before launching.",
  },
] as const;

export const Route = createFileRoute("/(public)/privacy/")({
  component: PrivacyPage,
  loader: () => ({
    crumb: m.auth_privacy_crumb(),
  }),
});

function PrivacyPage() {
  return (
    <div className="min-h-svh px-6 py-10 md:px-10">
      <div className="mx-auto w-full max-w-2xl">
        <a href="/" className="mb-10 inline-flex items-center gap-2 font-medium">
          <img src={textLogo} alt={m.app_title()} className="h-12" />
        </a>

        <div className="space-y-1">
          <h1 className="text-3xl font-bold tracking-tight">{m.auth_legal_privacy()}</h1>
          <p className="text-sm text-muted-foreground">{m.auth_legal_last_updated({ date: LAST_UPDATED })}</p>
        </div>

        <div className="mt-10 space-y-8">
          {SECTIONS.map((section, index) => (
            <section key={section.title}>
              <h2 className="text-lg font-semibold">
                {index + 1}. {section.title}
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{section.body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
